const { getChildLinesForLine } = require('@/lib/Cart');
/**
 * Returns all the lines in the cart which are an option for the given line.
 *
 * @param {Cart} cart
 * @param {CartLine} cartLine
 *
 * @returns {CartLine[]}
 */
const getItemOptionLinesForLineFromCart = (cart, cartLine) => {
    return getChildLinesForLine(cart, cartLine).filter((line) => {
        return line.optionSet;
    });
};

/**
 * TODO: This might not be needed in the end if we can use
 * the getItemOptionSelections method on the line reliably.
 *
 * Returns the currently selected options for a cart line.
 *
 * This is a simple object with the format:
 * {
 *      optionSetID: [itemOptionID],
 *      optionSetID: [itemOptionID, itemOptionID, ...],
 * }
 *
 * Item options are not stored on the cart line to which they relate, but rather as separate lines in the cart
 * with a parentThirdPartyRef that points to the cart line they belong to.
 *
 * @param {Cart} cart
 * @param {CartLine} cartLine
 *
 * @returns {Object<number, number[]>}
 */
const getItemOptionSelectionsForLine = (cart, cartLine) => {
    const existingItemOptionLinesForLine = getItemOptionLinesForLineFromCart(cart, cartLine);

    return convertItemOptionLinesToOptionSelections(existingItemOptionLinesForLine);
};

/**
 * Converts an array of item option lines into the simple object format used to represent option selections.
 *
 * @param {CartLine[]} itemOptionLines
 *
 * @returns {OptionSelections}
 */
const convertItemOptionLinesToOptionSelections = (itemOptionLines) => {
    const selections = {};

    itemOptionLines.forEach((line) => {
        if (!selections[line.optionSet.ID]) {
            selections[line.optionSet.ID] = [];
        }
        selections[line.optionSet.ID].push(line.getItemID());
    });

    // Sort the optionSetID keys, and the itemOptionID values to ensure consistency when comparing.
    const sortedSelections = {};
    Object.keys(selections)
        .sort()
        .forEach((key) => {
            sortedSelections[key] = selections[key].sort();
        });

    return sortedSelections;
};

module.exports = {
    convertItemOptionLinesToOptionSelections,
    getItemOptionLinesForLineFromCart,
    getItemOptionSelectionsForLine,
};
